import { useSelector } from 'react-redux';
import { Machine, MachineGroup } from '@interfaces/machines';
import { selectMachines, selectSelectedItem } from '@reducers/machines';
import { selectSelectedGroup } from '@reducers/machinesV2';
import { ALL_MACHINES } from '@helpers';

export const useGetSelectedMachineIds = (): number[] => {
  const selectedMachine: Machine = useSelector(selectSelectedItem);
  const selectedGroup: MachineGroup = useSelector(selectSelectedGroup);
  const machines: Machine[] = useSelector(selectMachines);

  const isAllSelected = selectedMachine.id === ALL_MACHINES;
  const machinesIds = !isAllSelected
    ? [selectedMachine.machineId]
    : selectedGroup?.machines
    ? selectedGroup.machines.map((m) => m.machineId)
    : machines.map((m) => m.machineId);

  return machinesIds;
};
